
export const actionTypes = {
    USER_AUTH: 'USER_AUTH',
    CONSUMO_DATE: 'CONSUMO_DATE',
}